var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex space-x-4"},_vm._l((_vm.productLogos),function(logo,idx){return _c('div',{key:idx,attrs:{"logo":logo}},[_c('img',{staticClass:"w-12 ",attrs:{"src":logo,"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }